export const courseColumn = [
  {
    type: 'selection',
    width: 60,
    align: 'center'
  },
  {
    title: '未分班课程选择',
    align: 'center',
    className: 'before-divide-class-top-header',
    children: [
      {
        title: '课程名称',
        key: 'productName',
        minWidth: 120,
        align: 'center'
      },
      {
        title: '报名人数',
        key: 'enrollNum',
        width: 120,
        align: 'center'
      },
      {
        title: '是否开班',
        slot: 'isOpen',
        width: 100,
        align: 'center'
      }
    ]
  },
  {
    title: '开班管理',
    align: 'center',
    className: 'before-divide-class-top-header',
    children: [
      {
        title: '每班人数上限',
        slot: 'maxNum',
        width: 140,
        align: 'center'
      },
      {
        title: '周几上课（时间）',
        slot: 'classTimeDesc',
        minWidth: 140,
        align: 'center'
      },
      {
        slot: 'weekCycleNum',
        width: 120,
        align: 'center',
        renderHeader: (h, params) => {
          return h(
            'Tooltip',
            {
              props: {
                placement: 'top-start',
                transfer: true,
                'max-width': '300'
              }
            },
            [
              h('span', [
                h('Icon', { props: { type: 'ios-help-circle-outline' }}),
                h('span', '周期循环')
              ]),
              h(
                'span',
                { slot: 'content' },
                '每N周循环一周课次，请填写>=1的正整数'
              )
            ]
          );
        }
      },
      {
        title: '开课日期',
        slot: 'startTime',
        width: 150,
        align: 'center'
      },
      {
        title: '班级总课时',
        slot: 'classroomTotal',
        width: 120,
        align: 'center'
      },
      {
        title: '分班模式',
        slot: 'action',
        width: 200,
        align: 'center'
      }
    ]
  }
];
